<template>
  <div class="hello" id="DayReport">
    <div class="data_head">
      <span class="text_panel">参数</span>
      <el-cascader
        ref="cascaderAddr"
        v-model="value"
        :options="paramOptions"
        :props="{
          value: 'code',
          label: 'nameDesc',
          children: 'childHashSet',
          multiple: true,
        }"
        :show-all-levels="false"
        @change="changeLabel"
        collapse-tags
        clearable
      ></el-cascader>
      <el-date-picker
        v-model="searchDate"
        align="right"
        type="date"
        value-format="yyyy-MM-dd"
        :editable="false"
      ></el-date-picker>
      <el-button type="primary" @click="search()" class="searchButton"
        >查&nbsp;询</el-button
      >
      <el-button type="primary" class="searchButton" @click="download()"
        >下载</el-button
      >
    </div>

    <div class="table" style="height: 625px" id="table">
      <el-table
        v-show="searchMainNumber==='020601' && mainId=='213'"
        id="exportTab"
        :data="list"
        style="width: 100%"
        :header-cell-style="{ background: '#335ABB', color: '#FFF' }"
        :row-style="{ height: '36px' }"
        stripe
      >
        <el-table-column :label="tableTitle" align="center" width="100%">
          <el-table-column
            prop="reportDate"
            label="时间"
            width="100"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="measureNo"
            label="测点编号"
            align="center"
            width="100"
          ></el-table-column>
          <el-table-column
            prop="measureAlias"
            label="测点名称"
            align="center"
            width="100"
          ></el-table-column>
          <el-table-column label="期初值" align="center" width="120">
            <el-table-column
              prop="initialValsX"
              label="X"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="initialValsY"
              label="Y"
              align="center"
            ></el-table-column>
          </el-table-column>
          <el-table-column label="期末值" align="center" width="120">
            <el-table-column
              prop="endingValsX"
              label="X"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="endingValsY"
              label="Y"
              align="center"
            ></el-table-column>
          </el-table-column>
          <el-table-column label="最大值" align="center" width="120">
            <el-table-column
              prop="maxValsX"
              label="X"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="maxValsY"
              label="Y"
              align="center"
            ></el-table-column>
          </el-table-column>
          <el-table-column label="最小值" align="center" width="120">
            <el-table-column
              prop="minValsX"
              label="X"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="minValsY"
              label="Y"
              align="center"
            ></el-table-column>
          </el-table-column>
          <el-table-column label="平均值" align="center" width="120">
            <el-table-column
              prop="avgValsX"
              label="X"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="avgValsY"
              label="Y"
              align="center"
            ></el-table-column>
          </el-table-column>
          <el-table-column label="变化值" align="center" width="120">
            <el-table-column
              prop="variationValsX"
              label="X"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="variationValsY"
              label="Y"
              align="center"
            ></el-table-column>
          </el-table-column>
          <el-table-column label="极平均值" align="center" width="120">
            <el-table-column
              prop="rangeAvgX"
              label="X"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="rangeAvgY"
              label="Y"
              align="center"
            ></el-table-column>
          </el-table-column>
          <el-table-column label="累计位移" align="center" width="120">
            <el-table-column
              prop="totalDisX"
              label="X"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="totalDisY"
              label="Y"
              align="center"
            ></el-table-column>
          </el-table-column>
        </el-table-column>
      </el-table>
      <el-table
        v-show="!(searchMainNumber==='020601' && mainId=='213')"
        id="exportTab2"
        :data="list"
        style="width: 100%"
        :header-cell-style="{ background: '#335ABB', color: '#FFF' }"
        :row-style="{ height: '36px' }"
        stripe
      >
        <el-table-column :label="tableTitle" align="center">
          <el-table-column
            prop="reportDate"
            label="时间"
            width="150"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="measureNo"
            label="测点编号"
            align="center"
            width="120"
          ></el-table-column>
          <el-table-column
            prop="measureAlias"
            label="测点名称"
            align="center"
            width="150"
          ></el-table-column>
          <el-table-column
            prop="initialVals"
            label="期初值"
            align="center"
          >
          </el-table-column>

          <el-table-column
            prop="endingVals"
            label="期末值"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="maxVals"
            label="最大值"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="minVals"
            label="最小值"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="avgVals"
            label="平均值"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="variationVals"
            label="变化值"
            align="center">
          </el-table-column>
          <el-table-column
            prop="rangeAvg"
            label="极平均值"
            align="center">
          </el-table-column>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

Vue.filter("rounding", function (value) {
  if (!value) return "--";
  return parseFloat(value).toFixed(4);
});

export default {
  name: "DayReport",
  data() {
    return {
      measureNos: [],
      paramOptions: [],
      list: [],
      searchDate: "",
      tableTitle: "日报表", //日报表展示头部文字
      projectName: "", //下拉一级菜单名字
      navName: "", //首页选择八亩塘还是佛顶山
      value: [],
      shareScopeEnd: [], //结束时选中的 数据
      selectList: [], //查询选中的测点编号
      searchMainNumber: '',
      mainId: 0
    };
  },
    filters:{
        xdata(val){
            try {
                var arr = val.split(',')[0]
                return arr
            } catch (e) {
                return null
            }
        },
        ydata(val){
            try {
                var arr = val.split(',')[1]
                return arr
            } catch (e) {
                return null
            }
        },
        zdata(val){
            try {
                var arr = val.split(',')[2]
                return arr
            } catch (e) {
                return null
            }
        },
        xChange(val){
            try {
                var arr = val.split(',')[0]
                return arr
            } catch (e) {
                return null
            }
        },
        yChange(val){
            try {
                var arr = val.split(',')[1]
                return arr
            } catch (e) {
                return null
            }
        },
        zChange(val){
            try {
                var arr = val.split(',')[2]
                return arr
            } catch (e) {
                return null
            }
        },
        xChangeRate(val){
            try {
                var arr = val.split(',')[0]
                return arr
            } catch (e) {
                return null
            }
        },
        yChangeRate(val){
            try {
                var arr = val.split(',')[1]
                return arr
            } catch (e) {
                return null
            }
        },
        zChangeRate(val){
            try {
                var arr = val.split(',')[2]
                return arr
            } catch (e) {
                return null
            }
        },

    },
  mounted: function () {
    this.mainId = localStorage.getItem("mainId");
    this.$axios.get("/api/monitor/dataHistory/getMeasureByCode").then((res) => {
      this.paramOptions = res.data.datas.values;
    });
    this.yestertay();
    if (localStorage.getItem("mainId") == 24) {
      this.navName = "佛顶寺";
    }
    if (localStorage.getItem("mainId") == 25) {
      this.navName = "八亩唐";
    }
  },

    methods: {
    yestertay() {
      let date = new Date();
      date.setDate(date.getDate() - 1); // 直接设置为昨天

      let year = date.getFullYear();
      let month = String(date.getMonth() + 1).padStart(2, '0'); // 月份补零
      let day = String(date.getDate()).padStart(2, '0');        // 日期补零

      this.searchDate = `${year}-${month}-${day}`;
    },
    // 下拉参数选择 获取一级菜单名称
    changeLabel(val) {
      if (val.length !== 0) {
        this.projectName =
          this.$refs["cascaderAddr"].getCheckedNodes()[0].pathLabels[0];
      }
      let changeFlag = false;
      let changeItem = null;
      if (this.shareScopeEnd.length == 0) {
        this.value = val;
      } else {
        this.value.forEach((item) => {
          if (item[0] !== this.shareScopeEnd[0][0]) {
            // 一级标签不同、一级菜单不得多选
            changeFlag = true;
            changeItem = item;
          }
          // 一级菜单不得多选
          //   else if (item[1] != this.shareScopeEnd[0][1]) { // 一级标签相同但是二级标签不同
          //     changeFlag = true
          //     changeItem = item
          //   }
          //  else if ((!item[1] && this.shareScopeEnd[0][1]) || (item[1] && !this.shareScopeEnd[0][1])) {
          //     changeFlag = true
          //     changeItem = item
          //   }
          //   else if ((!item[2] && this.shareScopeEnd[0][2]) || (item[2] && !this.shareScopeEnd[0][2])) {
          //     changeFlag = true
          //     changeItem = item
          //   }
        });
      }
      if (changeFlag) {
        this.value = [];
        this.value.push(changeItem);
      }
      this.shareScopeEnd = this.value;
      this.selectList = [];
      this.shareScopeEnd.forEach((item) => {
        if (item.length === 3) {
          this.selectList.push(item[2]);
        } else {
          this.selectList = [];
        }
      });
    },
    search() {
      if (this.selectList.length === 0) {
        this.$message({
          type: "error",
          message: "请选择编号",
        });
        return
      }

      this.tableTitle = localStorage.getItem("projectTitle") + this.searchDate + "日报表"
      // console.log(this.searchDate)
      const result = [...new Set(this.selectList.map(item => item.substring(0, 6)))];
      if (result.length > 1 && result.indexOf("020601") >= 0) {
        this.$message({
          message: "查询倾角报表，只能选择一种传感器类型！",
          type: "warning",
          // duration:80000
        });
        return;
      }
      if (result.length === 1 && result[0] === '020601'){
        this.searchMainNumber = '020601'
      } else {
        this.searchMainNumber = ''
      }
      this.$axios
        .post(
          `/api/monitor/dataReport/dataDayReport`,{code: this.selectList.join(","), time: this.searchDate}
        )
        .then((res) => {
          let values = res.data.datas.values;
          if (this.searchMainNumber === '020601'){
            this.list = values.map(item => {
              try {
                let initialVals = this.dealDataValue(item.initialVals);
                item.initialValsX = initialVals[0]
                item.initialValsY = initialVals[1]

                let endingVals = this.dealDataValue(item.endingVals)
                item.endingValsX = endingVals[0]
                item.endingValsY = endingVals[1]

                let maxVals = this.dealDataValue(item.maxVals)
                item.maxValsX = maxVals[0]
                item.maxValsY = maxVals[1]

                let minVals = this.dealDataValue(item.minVals)
                item.minValsX = minVals[0]
                item.minValsY = minVals[1]

                let avgVals = this.dealDataValue(item.avgVals)
                item.avgValsX = avgVals[0]
                item.avgValsY = avgVals[1]

                let variationVals = this.dealDataValue(item.variationVals)
                item.variationValsX = variationVals[0]
                item.variationValsY = variationVals[1]

                let rangeAvg = this.dealDataValue(item.rangeAvg)
                item.rangeAvgX = rangeAvg[0]
                item.rangeAvgY = rangeAvg[1]
                let nums = item.variationVals.split(',').map(it =>  Number.parseFloat(it))
                item.totalDisX = (this.tanOfAngle(nums[0]) * 24).toFixed(3)
                item.totalDisY = (this.tanOfAngle(nums[1]) * 24).toFixed(3)
                return item
              } catch (e) {
                console.log(e)
                return {}
              }
            })
          } else {
            this.list = values;
          }
        });
    },
    download() {
      this.exportExcel();
    },
    exportExcel() {
      // this.pageNum = 1
      // this.pageSize = 20
      this.$nextTick(function () {
        /* generate workbook object from table */
        var xlsxParam = { raw: true }; // 导出的内容只做解析，不进行格式转换
        const tableId = this.searchMainNumber === '020601' && this.mainId === '213' ? 'exportTab' : 'exportTab2';
        var wb = XLSX.utils.table_to_book(
          document.querySelector(`#${tableId}`),
          xlsxParam
        );

        /* get binary string as output */
        var wbout = XLSX.write(wb, {
          bookType: "xlsx",
          bookSST: true,
          type: "array",
        });
        try {
          FileSaver.saveAs(
            new Blob([wbout], { type: "application/octet-stream" }),
            this.tableTitle + ".xlsx"
          );
        } catch (e) {
          if (typeof console !== "undefined") {
            console.log(e, wbout);
          }
        }
        // this.pageNum = 1
        return wbout;
      });
    },
      decimalToDMS(decimalDegree) {
        const degrees = Math.floor(decimalDegree); // 整数部分是度
        const minutesDecimal = (decimalDegree - degrees) * 60;
        const minutes = Math.floor(minutesDecimal); // 整数部分是分
        const seconds = ((minutesDecimal - minutes) * 60).toFixed(0); // 保留两位小数的秒

        return `${degrees}° ${minutes}′ ${seconds}″`;
      },
      dealDataValue(strValue){
        return strValue.split(",").map((item) => this.decimalToDMS(Number.parseFloat(item)));
      },

      degToRad(degrees) {
        return degrees * (Math.PI / 180);
      },

// 计算角度的 tan 值
      tanOfAngle(degrees) {
        const radians = this.degToRad(degrees);
        return Math.tan(radians);
      },
  },
};
</script>

<style>
#table .el-scrollbar__wrap {
  /*overflow-x: hidden;*/
  overflow-x: auto;
}
#table .el-scrollbar__wrap.special-table {
  overflow-x: auto;
}

#DayReport .el-cascader .el-input .el-input__inner {
  color: #fff;
  background-color: #3457de;
}

#DayReport .el-date-editor .el-input__inner {
  background-color: #3457de;
  color: #fff;
}

#DayReport .el-table {
  color: #a7ccf6;
}

#DayReport .el-table__row {
  background-color: #0b3a68 !important;
}

#DayReport .el-table--striped .el-table__body tr.el-table__row--striped td {
  background-color: #021535;
}

#DayReport .el-table td {
  border: unset;
}

#DayReport .el-table th.is-leaf {
  border-bottom: none;
}

#DayReport .el-date-editor--daterange.el-input__inner {
  background-color: #3457de;
}

#DayReport .el-date-editor .el-range-input {
  background-color: #3457de;
  color: #fff;
}

#DayReport .el-date-editor .el-range-separator {
  background-color: unset;
  color: #fff;
}
.table{
  margin: 15px;
}
</style>

<style scoped>
@import url("../../assets/css/style.css");
</style>




// WEBPACK FOOTER //
// src/components/reportManage/DayReportNew.vue